import TaxReturnForm from './TaxReturnForm'

const VatReport = () => {
  return (
    <div>
      <TaxReturnForm />
    </div>
  )
}

export default VatReport
